import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function FilterOffIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M0.499999 0.5C5.07954 6.36626 7.508 8.76297 13.5 13.5" strokeWidth="1"></path>
    <path id="Union" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m8.09435 12.3088 -1.40627 0.6102c-0.63823 0.277 -1.35132 -0.1906 -1.35132 -0.8861V9.34375m3.33917 0.14063V8.2553c1.87037 -1.21342 3.20387 -2.82774 4.13917 -4.56907 0.5809 -1.08142 -0.2946 -2.33711 -1.4096 -2.45351 -2.97277 -0.310315 -5.82568 -0.310312 -8.7984 0.00012 -0.4425 0.04621 -0.82565 0.23906 -1.10673 0.51767"
          strokeWidth="1"></path>
  </SvgIcon>
}
